module.exports = __webpack_public_path__ + "img/big_yuan.9c7a5d73.png";